import { connect } from "react-redux"
import { Dispatch } from "redux"
import {
  updateLives,
  updateMyFeedEpisodes,
  updateRecentEpisodes,
  updateRecommendEpisodes,
} from "../../actions/pages/topActionCreator"
import { getCurrentUser } from "../../libs/get-current-user"
import { RootState, ReduxAction } from "../../reducers"
import { IRootPagesState } from "../../reducers/pages"
import { ChatRoom } from "../../rpcs/dist/ChatRoomRPC"
import { Episode } from "../../rpcs/dist/EpisodeRPC"
import { User } from "../../rpcs/dist/UserRPC"

export interface IContainerProps {
  top: IRootPagesState["top"]
  currentUser: User | null
  actions: ActionDispatcher
}

export class ActionDispatcher {
  constructor(private dispatch: (action: ReduxAction) => void) {}

  public updateRecentEpisodes(episodes: Episode[]) {
    this.dispatch(updateRecentEpisodes(episodes))
  }

  public updateRecommendEpisodes(episodes: Episode[]) {
    this.dispatch(updateRecommendEpisodes(episodes))
  }

  public updateMyFeedEpisodes(episodes: Episode[]) {
    this.dispatch(updateMyFeedEpisodes(episodes))
  }

  public updateLives(lives: ChatRoom[]) {
    this.dispatch(updateLives(lives))
  }
}

const mapDispatchToProps = (dispatch: Dispatch<ReduxAction>) => ({
  actions: new ActionDispatcher(dispatch),
})

const mapStateToProps = ({ pages, loginData, switchingUser }: RootState) => ({
  top: pages.top,
  currentUser: getCurrentUser(loginData, switchingUser),
})

export const container = connect(mapStateToProps, mapDispatchToProps)
